export default __webpack_public_path__ + "locales/fr/EmbeddingPanel.json?hash=6dc911dd8f41e18b0bb3067b90ff2c8e";